export const CHAT_START_REQUEST = 'CHAT_START_REQUEST'
export const CHAT_START_SUCCESS = 'CHAT_START_SUCCESS'
export const CHAT_START_FAIL = 'CHAT_START_FAIL'
export const CHAT_START_RESET = 'CHAT_START_RESET'

export const CHAT_LIST_REQUEST = 'CHAT_LIST_REQUEST'
export const CHAT_LIST_SUCCESS = 'CHAT_LIST_SUCCESS'
export const CHAT_LIST_FAIL = 'CHAT_LIST_FAIL'

export const CHAT_MESSAGES_REQUEST = 'CHAT_MESSAGES_REQUEST'
export const CHAT_MESSAGES_SUCCESS = 'CHAT_MESSAGES_SUCCESS'
export const CHAT_MESSAGES_FAIL = 'CHAT_MESSAGES_FAIL'
export const CHAT_MESSAGE_RECEIVED = 'CHAT_MESSAGE_RECEIVED'
export const CHAT_MESSAGES_RESET = 'CHAT_MESSAGES_RESET'
